import React, { useContext, useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { ButtonSpinner, showAlertMsg } from '../../components/CommonMethod';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../components/Context';
import { onCheckoutSuccessEvent } from './CheckoutSuccess';

const IntentCheckout = () => {
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [, setContext] = useContext(Context);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async () => {
        if (!stripe || !elements) return;
        setIsProcessing(true);

        const paymentResponce = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/checkout-successful?payment_intent_id={CHECKOUT_SESSION_ID}`
            },
            redirect: 'if_required',
            // elementsOptions: {
            //     defaultValues: {
            //         billingDetails: {
            //             name: 'John Doe',
            //             email: 'john@example.com',
            //             email: 'john@example.com',
            //         }
            //     }
            // }
        });
        if (paymentResponce?.paymentIntent) {
            await onCheckoutSuccessEvent(`?payment_intent_id=${paymentResponce?.paymentIntent?.id}`, setContext, navigate);
        } else {
            showAlertMsg({ error: 'Opps something went wrong' });
        }
        setIsProcessing(false);
    };

    return (<>
        <form className="needs-validation" method="post" id="puchaseForm" noValidate autoComplete="off">
            <PaymentElement id="payment-element" />
            {/* <AddressElement options={{ mode: 'billing', defaultValues: { name: `${user?.biller_first_name} ${user?.biller_last_name}` } }} /> */}
            <div className="col-sm-12 py-3 d-flex justify-content-end">
                <button type="button" disabled={(!stripe || !elements || isProcessing)} className="btn btn-theme-primary minw-90 me-3" onClick={handleSubmit}>
                    <ButtonSpinner load={isProcessing} btnName="Stripe" />
                </button>
            </div>
        </form>
    </>);
};


export default IntentCheckout